
















import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import MainHead from '@/components/MainHead/index.vue'

@Component({
  name: 'AppMain',
  components: {
    MainHead,
    Breadcrumb
  }
})
export default class extends Vue {
  get isLoading() {
    return AppModule.isLoading
  }
  created() {}
}
